import React, { Fragment, LegacyRef, useState } from 'react';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './CardSliderBlock.scss';

// @ts-ignore
import Reveal from 'react-reveal/Reveal';

import Card from '../../Elements/Card/Card';
import Title from '../../Elements/Title/Title';
import { sendEvent } from '../../../utils';

interface ICardSliderBlockProps {
  context?: IContent;
}

const CardSliderBlock = ({ context }: ICardSliderBlockProps) => {
  const { cards } = context;
  const sliderRef: LegacyRef<HTMLDivElement> = React.createRef();
  const [dotSelected, setSelectedDot] = useState(0);

  const slideCards = (index: number) => {
    let slideTo;

    switch (index) {
      case 0:
        slideTo = 0;
        break;
      case cards.list.length - 1:
        slideTo = 1000;
        break;
      default:
        slideTo = index * 180;
    }

    setSelectedDot(index);
    sliderRef.current.scrollTo({ left: slideTo, behavior: 'smooth' });
  };

  return (
    <Fragment>
      <Title titles={context.cards.colorful_title} color="#FFD900" />
      <Reveal
        onReveal={() => sendEvent('compare welcome - tab displayed - scroll')}
      >
        <div className="block-cards">
          <div className="content">
            <div className="card-slider-container" ref={sliderRef}>
              <ul className="card-slider">
                {cards.list.map((card: any, index: number) => (
                  <Card key={index} info={card} index={index} />
                ))}
              </ul>
            </div>
            {cards.list.map((card: any, index: number) => (
              <span
                key={index}
                className="dot no-display-desktop"
                style={{
                  background: index === dotSelected ? '#102831' : 'white'
                }}
                onClick={() => slideCards(index)}
              />
            ))}
          </div>
        </div>
      </Reveal>
    </Fragment>
  );
};

export default withContent(CardSliderBlock);
